import { Action } from '@ngrx/store';
import { ToolsView } from '../../../_generated';

export enum ToolsAction {
  Load = '[Tools] Load',
  Get = '[Tools] Get',
  Reset = '[Tools] Reset',
}

export class Load implements Action {
  readonly type = ToolsAction.Load;
}

export class Get implements Action {
  readonly type = ToolsAction.Get;

  constructor(public payload: ToolsView[]) {}
}

export class Reset implements Action {
  readonly type = ToolsAction.Reset;
}

export type ToolsActionType = Load | Get | Reset;
